import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {
	RunNovaAgentProductionInput,
	RunNovaAgentProductionMutation,
} from './__generated__/RunNovaAgentProductionMutation.graphql';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';

// A production run: the agent runs against a real task for a customer, and the answer is saved to
// its own run record. Nothing is written back to the task itself — an answer is read beside the
// task, never posted into it.
//
// Only the saved record is selected, and only the three fields the invocation control needs to
// resolve its own state: the outcome and, where it failed, the failure type — the two that decide
// which state the control lands in — plus the status, which distinguishes a run that has not
// finished from one that finished badly. The answer text and the grounding account the Studio's
// breakdown renders are deliberately not selected — no customer surface shows either in this
// release, and selecting them would pull a large payload per row.
const mutation = graphql`
	mutation RunNovaAgentProductionMutation($input: RunNovaAgentProductionInput!) {
		runNovaAgentProduction(input: $input) {
			result {
				run {
					outcome
					status
					failureState
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<RunNovaAgentProductionInput>,
	onSuccess?: RelayOnCompleted<RunNovaAgentProductionMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return commitMutation<RunNovaAgentProductionMutation>(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
